import scheduler from "@homer.core/scheduler";
import whenImages from "@homer.core/when.images";
import application from "@homer.core/application";

scheduler.yield.low(whenImages).then(() => {
    const template = document.createElement("template");

    template.innerHTML = `
            <link rel="manifest" crossorigin="use-credentials" href="/manifest.json?module.version=${application.version}" />
            <link rel="icon" href="/favicon.ico" />
            <link rel="apple-touch-icon" href="/favicon/192x192.png" />
        `;

    document.head.appendChild(template.content);
});
